<script setup lang="ts">
import useCopyright from '@/composables/copyrightable';
import useDomain from '@/composables/domainDependable';
import ExternalLink from '@/components/common/ExternalLink.vue';
import StfContainer from '@/ui/container/StfContainer.vue';
import {computed} from 'vue';

const copyright = useCopyright();
const domain = useDomain();


const footer = ['Privacy Policy', 'Terms of Use', 'Contact Us'];

const navItems = computed(() => {
    const baseUrl = domain.website;
    
    return footer.map(itemName => {
        const footerItem = domain.footerItems.find(item => item.label === itemName);

        const href = footerItem ? `${baseUrl}${footerItem.url}` : baseUrl;

        return { text: itemName, href: href };
    });
});

</script>

<template>
    <StfContainer>
        <footer class="footer py-8">
            <div class="footer-content">
                <div class="logo">
                    <img src="/img/TM-Logo-Gray-Thin.png" alt="TM Logo" />
                </div>
                <div>
                    {{ copyright }}
                </div>
                <div class="links mt-4">
                    <ExternalLink
                        v-for="link in navItems"
                        :key="link.text"
                        :href="link.href"
                    >
                        {{ link.text }}
                    </ExternalLink>
                </div>
            </div>
        </footer>
    </StfContainer>
</template>

<style scoped>
.footer-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
  margin: 0 auto;
}

.logo img {
  height: 95px;
}

.links {
  display: flex;
  gap: 10px;
}

.links a {
  color: #2D76F6;
}

.links a:hover {
  text-decoration: underline;
}
</style>
